export const TRANSPORT_UPDATED_SET_UPDATED = "TRANSPORT_UPDATED_SET_UPDATED";
export const TRANSPORT_UPDATED_TOGGLE_LOADING =
  "TRANSPORT_UPDATED_TOGGLE_LOADING";
export const TRANSPORT_UPDATED_SET_ERROR = "TRANSPORT_UPDATED_SET_ERROR";
